import React from "react"
import { useSelector } from "react-redux"

import { selectScopedByClient } from "../../stores/appSlice"
import VendorTable from "./components/VendorTable"
import VendorForm from "./components/VendorForm"
import ImportForm from "../imports/ImportForm"
import BulkEditForm from "../bulkEdit/bulkEditForm"
import DashboardPlaceholder from "../../components/utilityComponents/placeholders/DashboardPlaceholder"

// import BillTable from "../vendors/components/VendorTable"

export default function VendorPage({ view, recordSelected }) {
    const scopedByClient = useSelector(selectScopedByClient)

    const renderView = () => {
        switch (view) {
            case "import":
                return renderImport()
            case "dashboard":
                return renderDashboard()
            case "index":
                return renderIndex()
            case "form":
                return renderForm()
            case "bills":
                return renderBills()
            case 'bulk_edit':
                return renderBulkEdit()   
            default:
                return renderDashboard()
        }
    }

    const renderDashboard = () => {
        if (!scopedByClient) {
            return null
        }

        return <DashboardPlaceholder />
    }

    const renderIndex = () => {
        if (scopedByClient) {
            return (
                <>
                    <VendorTable scopedByClient={scopedByClient} />
                </>
            )
        }

        return <VendorTable scopedByClient={scopedByClient} />
    }

    const renderImport = () => {
        // console.log('vendors render page')
        return <ImportForm dataType="vendor" />
    }

    const renderForm = () => {
        if (recordSelected) {
            return (
                <>
                    <h1>Edit Form</h1>
                    <VendorForm actionName="edit" />
                </>
            )
        }

        return (
            <>
                <h1>New Form</h1>
                <VendorForm actionName="new" />
            </>
        )
    }

    const renderBills = () => {
        return <h1>Vendor's Bills</h1>
    }

    const renderBulkEdit = () => {
        return <BulkEditForm dataType="vendor" />
    }

    return <>{renderView()}</>
}
